<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="510px"
      top="40vh"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义大屏地址"
      :append-to-body="false"
      :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" class="form" @submit.native.prevent="handleSubmit">
        <el-form-item label="" prop="panelSn">
          <el-input v-model="form.panelSn" placeholder="请输入识别码" maxlength="8">
            <template slot="prepend">{{ domain }}/view/</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updatePanelSnApi } from '../fetch.js'
export default {
  name: 'RenameDialog',
  props: {
    screenInfo: {
      type: Object,
    },
  },
  data () {
    const validatePanelSn = (rule, value, callback) => {
      this.checkPassFlag = false
      if (value === '') {
        callback(new Error('请输入'))
      } else if (!/^[A-Za-z\d]{4,8}$/.test(value)) {
        callback(new Error('请输入4-8位数字或大小写字母的识别码'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: true,
      form: {
        panelSn: null,
      },
      oldPanel: null,
      rules: {
        panelSn: [
          { required: true, message: '请输入', trigger: ['change', 'blur'] },
          { validator: validatePanelSn, trigger: ['change', 'blur'] },

        ],
      },
      domain: '',
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.domain = window.location.href
      this.oldPanel = this.screenInfo.panelSn
      this.form.panelSn = this.screenInfo.panelSn
    },
    handleClose () {
      this.$emit('close')
    },
    async handleSubmit () {
      try {
        await this.$refs.form.validate()
        await updatePanelSnApi({
          newPanelSn: this.form.panelSn,
          oldPanelSn: this.oldPanel,
        })
        this.$emit('close', true)
      } catch (e) {
        this.$error(e)
      } finally {
      }
    },

  },
}
</script>

<style lang='scss' scoped>

  ::v-deep .el-dialog__wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  ::v-deep .el-dialog{
    margin: auto !important;
    border-radius: 4px!important;
    .el-dialog__header{
      padding: 15px 15px 10px!important;
      color: #1C1C1C;
      .el-dialog__title {

        font-size: 16px !important;
      }

    }
    .el-dialog__body{
      display: flex;
      justify-content: center;
      padding:15px 20px!important;
      .el-input-group__prepend {
        width: 360px;
      }

    }
    .el-input__inner{
      height: 46px;
    }
  }
</style>
